export const homeDictionary = {
    "Buscá por cotizaciones, títulos o empresas": {
        es: "Buscá por cotizaciones, títulos o empresas",
        en: "Search by quotes, titles, or companies",
    },
    "Explorá rápidamente las inversiones y activos con mayor y menor rendimiento": {
        es: "Explorá rápidamente las inversiones y activos con mayor y menor rendimiento",
        en: "Quickly explore the highest and lowest performing investments and assets",
    },
    "Seleccioná una inversión y en un vistazo observa las cotizaciones, títulos y empresas que con el mayor y menor rendimiento.":
        {
            es: "Seleccioná una inversión y en un vistazo observa las cotizaciones, títulos y empresas que con el mayor y menor rendimiento.",
            en: "Select an investment and at a glance see the quotes, titles, and companies with the highest and lowest performance.",
        },
    "Panel Acciones": {
        es: "Panel Acciones",
        en: "Stocks Panel",
    },
    "Panel General": {
        es: "Panel General",
        en: "General Panel",
    },
    "Panel Líder": {
        es: "Panel Líder",
        en: "Leader Panel",
    },
    "Panel Cedears": {
        es: "Panel Cedears",
        en: "Cedears Panel",
    },
    "Panel Bonos": {
        es: "Panel Bonos",
        en: "Bonds Panel",
    },
    "Panel Opciones": {
        es: "Panel Opciones",
        en: "Options Panel",
    },
    "Panel bonos": {
        es: "Panel bonos",
        en: "Bonds Panel",
    },
    "Panel Cauciones": {
        es: "Panel Cauciones",
        en: "Guarantees Panel",
    },
    "Panel Futuros": {
        es: "Panel Futuros",
        en: "Futures Panel",
    },
    "Mayor rendimiento": {
        es: "Mayor rendimiento",
        en: "Highest Return",
    },
    "Peor rendimiento": {
        es: "Menor rendimiento",
        en: "Lowest Return",
    },
    "Más operados": {
        es: "Más operados",
        en: "Most Traded",
    },
    "Conocé más acerca de nuestros productos": {
        es: "Conocé más acerca de nuestros productos",
        en: "Learn more about our products",
    },
    "Cotizaciones del mercado financiero": {
        es: "Cotizaciones del mercado financiero",
        en: "Financial market quotes",
    },
    "Fuente" : {
        es: "Fuente",
        en: "Source",
    },
    "Fuente provista por BYMA y CAFCI. Los valores de cuotapartes se actualizan en forma diaria, el resto de los datos son diferidos en aproximadamente 20 minutos. Salvo Error u Omisión (SEUO).": {
        es: "Fuente provista por BYMA y CAFCI. Los valores de cuotapartes se actualizan en forma diaria, el resto de los datos son diferidos en aproximadamente 20 minutos. Salvo Error u Omisión (SEUO).",
        en: "Source provided by BYMA and CAFCI. The share value is updated daily, while the rest of the data is delayed by approximately 20 minutes. Except for errors or omissions (SEUO).",
    },
    "La variacion corresponde a la ultima semana corriente": {
        es: "La variación corresponde a la ultima semana corriente",
        en: "The variation corresponds to the current week's last update",
    }
};
